import React from 'react'

import { useDispatch } from 'react-redux'
import paths from 'shared/config/paths'
import { showOnBoardingV2Modal } from 'shared/store/actions/modal'
import { track } from 'shared/store/actions/tracking'

import popoverStyles from 'conversations/components/NewChatSidebar/PopoverMenu/styles.module.css'

export const HelpMenu: React.FC = () => {
  const dispatch = useDispatch()

  return (
    <>
      <div className={popoverStyles.menu}>
        <div
          data-ocweb-id="NewProductTour"
          className={popoverStyles.item}
          onClick={() => {
            dispatch(showOnBoardingV2Modal({ fromHelp: true }))
          }}>
          Take the product tour
        </div>
        <div
          data-ocweb-id="WatchVideoTutorial"
          className={popoverStyles.item}
          onClick={() => {
            dispatch(track({ name: 'Clicked "Watch a video tutorial"' }))
            window.open(paths.TUTORIAL_VIDEO_URL)
          }}>
          Watch a video tutorial
        </div>
        <a target="external" href={paths.TROUBLESHOOTING_URL} data-ocweb-id="GetHelp">
          <div className={popoverStyles.item}>Get help</div>
        </a>
      </div>
    </>
  )
}
